<template>
<b-container fluid class="container">
   <b-row class="justify-content-md-center">
          <b-col col md="3" class="text-center">
           <Descripcion/>
            <div class="mb-5" >
                  <img src="../assets/wizard1.png" class="img-fluid" alt="" />
            </div>
            <hr>
            <div class="mb-5">
              <h6>Estamos para ayudarte</h6>
              <p style="font-size: 15px">¿Deseas ser asistido por uno de nuestros asesores?</p>
                  <b-button @click.prevent="" variant="outline-primary" class="button_H11">Estamos para ayudarte</b-button>
            </div>
          </b-col>
          <b-col  col md="9" class="card-body text-center">
            <Sesion/>
            <h1 class="mt-5">Bienvenido</h1>
            <p class="mt-5">Seleciona la opción de compra que desees</p>
              <b-row class="mt-5" v-if="this.entrada == true" >
                <b-col>
                  <b-button @click.prevent="reserva()" class="button_H1">QUIERO APARTAR EL AUTO</b-button>
                </b-col>
                <b-col>
                  <b-button @click.prevent="cotiza()" class="button_H1">ME INTERESA COTIZAR</b-button>
                </b-col>
              </b-row>
              <b-row class="mt-5" v-if="this.operaciones == true">
                <b-col>
                  <b-button @click.prevent="financiamiento()" variant="outline-primary" class="button_H1">FINANCIAMIENTO</b-button>
                </b-col>
                <b-col>
                  <b-button @click.prevent="contado()" variant="outline-primary" class="button_H1">CONTADO</b-button>
                </b-col>
              </b-row>
                <b-row align-h="center" class="justify-content-md-center m-auto">
                  <b-col md="6" lg="6" sm="6" class="mt-2 rounded">
                      <b-button @click.prevent="regresar()" class="button_H">REGRESAR</b-button>
                  </b-col>
                </b-row>
          </b-col>
    </b-row>
</b-container>
</template>

<script>
import Sesion from './Sesion.vue';
import Descripcion from './Descripcion.vue';

export default {
  name: 'Bienvenida',

  components: {
    Sesion,
    Descripcion
  },

    data() {
    return {
      vin: sessionStorage.getItem("vin"),
      type: sessionStorage.getItem("type"),
      operaciones: false,
      entrada: true

      };
  },

  methods: {

    reserva(){
            this.$router.push({ path: '/Reserva'});
    },

    cotiza(){
      this.entrada = false;
      this.operaciones = true;
    },
    
    financiamiento(){
            this.$router.push({ path: '/Financiamiento'});
    },  
    
    contado(){
            this.$router.push({ path: '/Contado'});
    },  

    formatPrice(value) {
        let val = (value/1).toFixed(0).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    formatPriceCostos(value) {
        let val = (value/1).toFixed(2).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    regresar(){
      window.history.go(-1);
    },

    datos(){
      console.log('Entrando a datos Bienvenida --> ',this.vin +' '+this.type);
      if( this.vin == 'undefined' && this.type == 'undefined'){
        sessionStorage.setItem("vin", this.$route.query.vin);
        sessionStorage.setItem("type", this.$route.query.type);
      }

      if( this.vin == null && this.type == null){
        sessionStorage.setItem("vin", this.$route.query.vin);
        sessionStorage.setItem("type", this.$route.query.type);
      }
   
    }

  },
  
  created() {
    this.datos();
  }
}
</script>

<style scoped>


</style>